import styled from '@emotion/styled';

import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import COLORS, { COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const Container = styled.div`
  padding: ${SPACING.LG};

  ${MEDIA_QUERY.MOBILE} {
    padding: ${SPACING.MD};
  }
  ${MEDIA_QUERY.MOBILE_XS} {
    padding: 24px 16px 16px;
  }
`;

export const Title = styled.div`
  color: ${COLORS_TEXT.PRIMARY};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGE)}
`;

export const Subtitle = styled.div`
  color: ${COLORS_TEXT.BODY};
  margin-top: ${SPACING.SM};
  margin-bottom: ${SPACING.S32};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}

  ${MEDIA_QUERY.MOBILE} {
    margin-top: ${SPACING.XS};
    margin-bottom: ${SPACING.MD};
  }
`;

const GRID_ITEM_PADDING = '6px';

export const Grid = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin: -${GRID_ITEM_PADDING};

  ${MEDIA_QUERY.MOBILE_XS} {
    margin: -4px;
  }
`;

export const GridItem = styled.div`
  flex: 0 0 auto;
  padding: ${GRID_ITEM_PADDING};
  position: relative;
  width: 8.3%;

  ${MEDIA_QUERY.MOBILE_XS} {
    padding: 4px;
  }
`;

type ColorProps = {
  value: string;
};
export const Color = styled.div<ColorProps>`
  background-color: #${props => props.value};
  border: 1px solid ${COLORS.ALTO};
  border-radius: 100%;
  position: relative;

  &:before {
    content: '';
    display: block;
    height: 0;
    padding-bottom: 100%;
  }
`;
